import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, AlertController } from 'ionic-angular';
import { EventoAdversoModel } from './evento-adverso.modelview';
import { EventoAdversoPageProvider } from './evento-adverso.provider';
import { duration } from 'moment';

/**
 * Generated class for the EventoAdversoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-evento-adverso',
  templateUrl: 'evento-adverso.html',
})
export class EventoAdversoPage {
  model: EventoAdversoModel;
  title: string;
  isBrowser: boolean = false;

  today

  constructor(public navCtrl: NavController,
    public provider: EventoAdversoPageProvider,
    public loadingCtrl: LoadingController,
    private toastController: ToastController,
    private alertController: AlertController,
    public navParams: NavParams) {

    this.today = new Date().toISOString()

    this.model = new EventoAdversoModel()
    this.title = navParams.get("title")
    this.isBrowser = this.navParams.get("isBrowser")
    this.solicitarListas()
    this.solicitarNomeDeProdutos()
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventoAdversoPage');
    this.solicitarDadosUsuario()
  }

  solicitarNomeDeProdutos() {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present().then(() => {

      this.provider.requestProducts().subscribe((names) => {
        this.model.produtos = names
        loading.dismiss()
      }, (err) => {
        loading.dismiss()
      })
    })
  }

  solicitarListas() {

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present().then(() => {

      this.provider.requestLists().subscribe((data) => {
        loading.dismiss()
        this.model.especialidades = data.especialidades_medico
        this.model.estados = data.estados
      }, err => {
        loading.dismiss()
      })

    })
  }

  solicitarDadosUsuario() {
    this.provider.getUserData().subscribe(user => {
      this.model.nome_relator = user.general.data.display_name
      this.model.telefone_relator = user.acf.celular
      this.model.email_relator = user.general.data.user_email

      this.model.nome_medico = user.general.data.display_name
      this.model.telefone_medico = user.acf.celular
      this.model.crm_medico = user.acf["crm-medico"]
      this.model.especialidade_medico = user.acf.especialidades_medico
      this.model.estado = user.acf.uf

    })
  }

  sendFormulary() {

    if (this.validationOfFields()) {
      return;
    }

    let loading = this.loadingCtrl.create({
      content: 'Enviando...'
    });
    loading.present().then(() => {
      this.provider.enviarEventoAdverso(this.model).subscribe(data => {

        let toast = this.toastController.create({
          message: "Evento enviado com sucesso!",
          duration: 3000,
          position: 'bottom'
        });

        loading.dismiss().then(() => {
          toast.present()
        })
      })
    })
  }


  finalSelected(event) {
    if (this.model.data_inicio != undefined) {
      let start = Date.parse(this.model.data_inicio)
      let finish = Date.parse(event)
      if (finish < start) {
        this.toastController.create({
          message: "Data de Término deve ser posterior a de inicio",
          duration: 3000,
        }).present()
        new Promise(resolve => setTimeout(() => {
          this.model.data_termino = ""
        }, 500))
      }
    }
  }

  startSelected(event) {
    if (this.model.data_termino != undefined) {
      let start = Date.parse(event)
      let finish = Date.parse(this.model.data_termino)
      if (start > finish) {
        this.toastController.create({
          message: "Data de Início deve ser anterior a de término",
          duration: 3000
        }).present()

        new Promise(resolve => setTimeout(() => {
          this.model.data_inicio = ""
        }, 500))
      }
    }
  }

  validationOfFields() {

    if(this.model.nome_relator == undefined || this.model.nome_relator == ""){
      this.showMessageError("Preencha o nome do relator")
      return true;
    }

    if(this.model.telefone_relator == undefined || this.model.telefone_relator == ""){
      this.showMessageError("Preencha o telefone do relator")
      return true;
    }

    if(this.model.produto == undefined || this.model.produto == ""){
      this.showMessageError("Selecione o produto")
      return true;
    }

    if(this.model.descricao_evento == undefined || this.model.descricao_evento == ""){
      this.showMessageError("Preencha a descrição do evento")
      return true;
    }

  }

  showMessageError(message: string) {
    let alert = this.alertController.create({
      title: message,
      buttons: ['Fechar']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/evento-adverso/evento-adverso.ts